<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="false"
    :isAdd="false"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["client_id", "discipline_id"],
  created() {
    this.itemLink = `business/clients/${this.client_id}/disciplines/${this.discipline_id}/reports`;
    this.setLink = `business/clients/${this.client_id}/disciplines/${this.discipline_id}/reports`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "course_group",
      fields: [
        {
          col: "col-12 col-md-6",
          label: "Выберите ученика",
          key: "client",
          type: "select",
          selectKey: "full_name",
          modal: "client",
          prefix: "group_client",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "description",
          title: "prev_notes",
          checkbox: false,
          label: "prev_notes",
          lang: true,
        },

        {
          key: "created_at",
          title: "",
          checkbox: false,
          disableLink: true,
          dateTimeFormat: true,
          object: "join_at",
          align: "right",
        },
      ],
    };
  },
};
</script>
<style>
</style>
